<!-- 分步骤add -->
<template>
  <ykc-form class="el-form-wrap">
    <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
      <div class="form-section-title">商户信息</div>
      <ykc-form-item label="合作方名称" prop="partnerName">
        <ykc-input
          placeholder="请输入合作方名称"
          maxlength="50"
          v-model="ruleForm.partnerName"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="公司名称" prop="companyName">
        <ykc-input
          placeholder="请输入公司名称"
          maxlength="50"
          v-model="ruleForm.companyName"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="公司类型" prop="companyType">
        <ykc-dropdown
          :data="companyTypeData"
          v-model="ruleForm.companyType"
          @change="handleCompanyTypeChange"></ykc-dropdown>
      </ykc-form-item>
      <ykc-form-item label="公司电话" prop="companyPhone">
        <ykc-input placeholder="请输入公司电话" v-model="ruleForm.companyPhone"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="公司地址" prop="companyAddress">
        <ykc-input placeholder="请输入公司地址" v-model="ruleForm.companyAddress"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="法人姓名" prop="legalPersonName">
        <ykc-input placeholder="请输入法人姓名" v-model="ruleForm.legalPersonName"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="法人身份证号" prop="legalPersonIdCard">
        <ykc-input
          placeholder="请输入法人身份证号"
          maxlength="18"
          v-model="ruleForm.legalPersonIdCard"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="联系人姓名" prop="contactName">
        <ykc-input placeholder="请输入联系人姓名" v-model="ruleForm.contactName"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="联系人手机号" prop="contactPhone">
        <ykc-input placeholder="请输入联系人手机号" v-model="ruleForm.contactPhone"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="联系人职务" prop="contactJob">
        <ykc-input placeholder="请输入联系人职务" v-model="ruleForm.contactJob"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="归属地区" prop="cityId">
        <ykc-cascader
          :options="cityData"
          v-model="ruleForm.cityId"
          @change="selectChange"></ykc-cascader>
      </ykc-form-item>
      <ykc-form-item label="统一社会信用代码" prop="socialCreditCode">
        <ykc-input
          placeholder="请输入统一社会信用代码"
          maxlength="18"
          minlength="18"
          bottomTip="温馨提示：请认真核对营业执照上的18位编码"
          v-model="ruleForm.socialCreditCode"></ykc-input>
      </ykc-form-item>
      <div class="form-section-title">银行账户信息</div>
      <!-- 公司类型为个体工商户时才需填写银行账号类型，企业默认对公户（提交值1） -->
      <ykc-form-item label="银行账号类型" prop="bankAccountType" v-if="ruleForm.companyType === 2">
        <ykc-dropdown
          :data="bankAccountTypeData"
          v-model="ruleForm.bankAccountType"
          @change="handleBankAccountTypeChange"></ykc-dropdown>
      </ykc-form-item>
      <ykc-form-item label="银行账号" prop="bankAccount">
        <ykc-input placeholder="请输入卡号" v-model="ruleForm.bankAccount"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="银行账户名" prop="bankAccountName">
        <ykc-input placeholder="请输入户名" v-model="ruleForm.bankAccountName"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="银行预留手机号" prop="bankPhone">
        <ykc-input
          placeholder="请输入银行预留手机号"
          maxlength="11"
          v-model="ruleForm.bankPhone"></ykc-input>
      </ykc-form-item>
      <ykc-form-item label="开户行行号" prop="bankOpenNo" :rules="bankOpenNoRules">
        <ykc-input
          placeholder="请输入开户行行号"
          maxlength="20"
          v-model="ruleForm.bankOpenNo"></ykc-input>
      </ykc-form-item>
      <div class="form-section-title">经营属性</div>
      <ykc-form-item label="开票种类" prop="invoiceType">
        <ykc-radio :data="invoiceTypeData" v-model="ruleForm.invoiceType"></ykc-radio>
      </ykc-form-item>
      <ykc-form-item prop="businessLicenseUrl" label="营业执照" class="file-error" bottomTip=" ">
        <ykc-upload
          ref="licence"
          :size="1"
          @handleRemove="removeLicence"
          @handleChange="uploadBusinessLicence"></ykc-upload>
      </ykc-form-item>
    </ykc-form>
  </ykc-form>
</template>
<script>
  import regexpObj from '@/utils/regexp';
  import { operatorData, treeUtils, uploadUtils } from '@/service/apis';

  export default {
    props: {
      data: {
        type: Object,
      },
    },
    name: 'AddOrEdit',
    data() {
      return {
        detail: {},
        cityData: [],
        invoiceTypeData: [
          { id: 1, name: '普票' },
          { id: 2, name: '专票' },
        ],
        companyTypeData: [
          { id: 1, name: '企业' },
          { id: 2, name: '个体工商户' },
        ],
        bankAccountTypeData: [
          { id: 1, name: '企业对公户' },
          { id: 2, name: '法人对私卡' },
        ],

        ruleForm: {
          partnerName: '',
          companyType: 1,
          companyName: '',
          companyPhone: '',
          companyAddress: '',
          cityId: [],
          contactName: '',
          contactPhone: '',
          contactJob: '',
          socialCreditCode: '',
          invoiceType: '',
          businessLicenseUrl: '',
          bankAccount: '',
          bankAccountName: '',
          bankOpenNo: '',
          bankAccountType: 1,
          bankPhone: '',
          legalPersonName: '',
          legalPersonIdCard: '',
        },
        rules: {
          partnerName: [
            { required: true, message: '请输入合作方名称', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.nameType.regexp,
              message: regexpObj.regexp.input.nameType.errorTips.error('商户名称'),
            },
          ],
          companyType: [{ required: true, message: '请选择公司类型', trigger: 'blur' }],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.nameType.regexp,
              message: regexpObj.regexp.input.nameType.errorTips.error('公司名称'),
            },
          ],
          companyPhone: [{ required: true, message: '请输入公司电话', trigger: 'blur' }],
          companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
          cityId: [{ required: true, message: '请选择归属地区', trigger: 'change' }],
          contactName: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
          contactPhone: [
            { required: true, message: '请输入联系人手机号', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.cellphoneType.regexp,
              message: regexpObj.regexp.input.cellphoneType.errorTips.error('手机号'),
            },
          ],
          contactJob: [{ required: true, message: '请输入联系人职务', trigger: 'blur' }],
          socialCreditCode: [
            { required: true, message: '请输入18位社会统一信用代码', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.creditCode.regexp,
              message: regexpObj.regexp.input.creditCode.errorTips.error('社会统一信用代码'),
            },
          ],
          invoiceType: [{ required: true, message: '请选择开票种类', trigger: 'blur' }],
          businessLicenseUrl: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
          bankAccount: [{ required: true, message: '请输入银行账号', trigger: 'blur' }],
          bankAccountName: [{ required: true, message: '请输入银行账户名', trigger: 'blur' }],
          bankAccountType: [{ required: true, message: '请选择银行账号类型', trigger: 'blur' }],
          bankPhone: [
            { required: true, message: '请输入银行预留手机号', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.cellphoneType.regexp,
              message: regexpObj.regexp.input.cellphoneType.errorTips.error('手机号'),
            },
          ],
          legalPersonName: [{ required: true, message: '请输入法人姓名', trigger: 'blur' }],
          legalPersonIdCard: [
            { required: true, message: '请输入法人身份证号', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
              message: '请输入正确的18位身份证号码',
            },
          ],
        },
      };
    },
    created() {
      // 编辑回显：默认带出意向单信息，支持二次编辑
      this.ruleForm.partnerName = this.data.name;
      this.ruleForm.companyName = this.data.name;
      this.ruleForm.contactName = this.data.contactName;
      this.ruleForm.contactPhone = this.data.mobile;
      this.ruleForm.contactJob = this.data.job;

      this.getCityTree();
    },
    computed: {
      // 对公必填，对私选填
      bankOpenNoRules() {
        if (this.ruleForm.bankAccountType === 1) {
          return [{ required: true, message: '请输入开户行行号', trigger: 'blur' }];
        }
        return [];
      },
      formData() {
        const cityId =
          Array.isArray(this.ruleForm.cityId) && this.ruleForm.cityId.length > 0
            ? this.ruleForm.cityId[this.ruleForm.cityId.length - 1]
            : null;
        const formData = {
          ...this.ruleForm,
          cityId,
          intentionId: this.data.id,
          status: 1,
        };

        return formData;
      },
    },
    methods: {
      uploadBusinessLicence(file, fileList, isCheck) {
        this.uploadImg(file, fileList, isCheck, 'businessLicenseUrl');
      },
      removeLicence() {
        this.ruleForm.businessLicenseUrl = '';
        this.$refs.ruleForm.validateField('businessLicenseUrl');
      },
      uploadImg(_file, _fileList, isCheck, type) {
        if (isCheck) {
          const formData = new FormData();
          const param = {
            file: _file.raw,
            bizName: '',
          };
          // 处理入参格式
          Object.entries(param).forEach(([k, v]) => {
            formData.append(k, v);
          });
          uploadUtils.uploadImg(formData).then(url => {
            this.ruleForm[type] = url;
            this.$refs.ruleForm.validateField(type);
          });
        }
      },
      getCityTree() {
        treeUtils.getDistrict({ level: '3' }).then(res => {
          this.cityData = res.districts || [];
          // 优先使用后端返回的城市级联路径，否则用 provinceId + cityId 组装
          if (this.data.cityPath && this.data.cityPath.length > 0) {
            this.ruleForm.cityId = this.data.cityPath;
          } else if (this.data.provinceId && this.data.cityId) {
            this.ruleForm.cityId = [this.data.provinceId, this.data.cityId];
          }
        });
      },
      /**
       * 归属地区选择
       */
      selectChange(value) {
        this.ruleForm.cityId = value || [];
      },
      /**
       * 公司类型改变
       */
      handleCompanyTypeChange() {
        this.ruleForm.bankAccountType = 1;
        this.ruleForm.bankAccount = '';
        this.ruleForm.bankOpenNo = '';
        this.ruleForm.bankPhone = '';
        this.ruleForm.legalPersonName = '';
        this.ruleForm.legalPersonIdCard = '';
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
        });
      },

      /**
       * 账号类型改变
       */
      handleBankAccountTypeChange() {
        this.$nextTick(() => {
          this.$refs.ruleForm && this.$refs.ruleForm.clearValidate('bankOpenNo');
        });
      },

      /** 表单提交事件，用于父组件定义的"完成"或"保存"按钮点击事件 */
      submitForm() {
        return new Promise((resolve, reject) => {
          this.validateAllForm()
            .then(() => {
              operatorData
                .auditList(this.formData)
                .then(() => {
                  this.$message({
                    message: '保存成功',
                    type: 'success',
                  });
                  resolve();
                })
                .catch(error => {
                  this.$message.error(error?.message || '保存失败');
                  reject(error);
                });
            })
            .catch(reject);
        });
      },
      /** 校验当前表格是否通过 */
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              resolve();
              setTimeout(() => {
                if (this.ruleForm.businessLicenseUrl !== '') {
                  this.$refs.licence.fileList = [{ url: this.ruleForm.businessLicenseUrl }];
                }
              }, 100);
            } else {
              reject();
            }
          });
        });
      },
      /** 校验所有表格是否通过 */
      validateAllForm() {
        return new Promise((resolve, reject) => {
          Promise.all(
            Object.keys(this.$refs)
              .filter(o => o.includes('ruleForm'))
              .map(o => {
                return new Promise((_resolve, _reject) => {
                  this.$refs[o].validate(valid => {
                    if (valid) {
                      _resolve();
                    } else {
                      _reject();
                    }
                  });
                });
              })
          )
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .upload-img-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .form-section-title {
    width: 100%;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 600;
    color: #000;
  }
</style>
